import React from 'react';
import { useSigners } from './useLayoff';
import styles from './layoff.module.scss';

/**
 * Native select of active Superintendents and Admins
 */
const SignerSelect = ({ id, value, onChange, invalid, excludeHashes = [] }) => {
  const { data: signers = [], isLoading } = useSigners();

  return (
    <select
      id={id}
      className={`${styles.select} ${invalid ? styles.invalid : ''}`}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      disabled={isLoading}
    >
      <option value=''>
        {isLoading ? 'Loading...' : 'Choose a Superintendent or Admin'}
      </option>
      {signers
        .filter((signer) => !excludeHashes.includes(signer.hash))
        .map((signer) => (
          <option key={signer.hash} value={signer.hash}>
            {signer.name} ({signer.role}
            {signer.crew ? `, ${signer.crew}` : ''})
          </option>
        ))}
    </select>
  );
};

export default SignerSelect;
